// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export enum Country {
  BY = 'BY',
  PL = 'PL',
  DE = 'DE',
  RU = 'RU',
  AT = 'AT',
  BE = 'BE',
  BG = 'BG',
  CH = 'CH',
  HR = 'HR',
  CY = 'CY',
  CZ = 'CZ',
  DK = 'DK',
  EE = 'EE',
  FI = 'FI',
  FR = 'FR',
  GR = 'GR',
  HU = 'HU',
  IE = 'IE',
  IT = 'IT',
  LV = 'LV',
  LT = 'LT',
  LU = 'LU',
  MT = 'MT',
  NL = 'NL',
  PT = 'PT',
  RO = 'RO',
  SK = 'SK',
  SI = 'SI',
  ES = 'ES',
  SE = 'SE',
  TR = 'TR',
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export enum Currency {
  EUR = 'EUR',
  USD = 'USD',
  CZK = 'CZK',
  CHF = 'CHF',
  DKK = 'DKK',
  HUF = 'HUF',
  RON = 'RON',
  SEK = 'SEK',
  PLN = 'PLN',
  BYN = 'BYN',
  RUB = 'RUB',
}

export const COUNTRY_CURRENCY_MAP: Record<string, string> = {
  [Country.BY]: Currency.BYN,
  [Country.PL]: Currency.PLN,
  [Country.DE]: Currency.EUR,
  [Country.RU]: Currency.RUB,
  [Country.AT]: Currency.EUR,
  [Country.BE]: Currency.EUR,
  [Country.BG]: Currency.EUR,
  [Country.CH]: Currency.CHF,
  [Country.HR]: Currency.EUR,
  [Country.CY]: Currency.EUR,
  [Country.CZ]: Currency.CZK,
  [Country.DK]: Currency.DKK,
  [Country.EE]: Currency.EUR,
  [Country.FI]: Currency.EUR,
  [Country.FR]: Currency.EUR,
  [Country.GR]: Currency.EUR,
  [Country.HU]: Currency.HUF,
  [Country.IE]: Currency.EUR,
  [Country.IT]: Currency.EUR,
  [Country.LV]: Currency.EUR,
  [Country.LT]: Currency.EUR,
  [Country.LU]: Currency.EUR,
  [Country.MT]: Currency.EUR,
  [Country.NL]: Currency.EUR,
  [Country.PT]: Currency.EUR,
  [Country.RO]: Currency.RON,
  [Country.SK]: Currency.EUR,
  [Country.SI]: Currency.EUR,
  [Country.ES]: Currency.EUR,
  [Country.SE]: Currency.SEK,
  [Country.TR]: Currency.EUR,
}
